/* 订单管理-订单录入 */
<template>
  <div id="orderInfo" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn color="primary" @click="toAddOrder" label="创建订单" icon="order" />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.customerNo" :options="customerList" option-label="customerName"
            option-value="customerNo" emit-value map-options label="客户名称" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined v-model="queryForm.orderNo" label="订单编号" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined v-model="queryForm.customerOrderNo" label="客户订单号" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.yarnType" :options="yarnList" option-label="typeName" option-value="id"
            emit-value map-options label="纱支类型" dense clearable />
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.roundType" label="成型状态" emit-value map-options dense clearable outlined :options="[
            { value: '筒纱', label: '筒纱' },
            { value: '绞纱', label: '绞纱' },
          ]">
          </q-select>
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.delivery" label="是否购销" emit-value map-options dense clearable outlined :options="[
            { value: '是', label: '是' },
            { value: '否', label: '否' },
          ]">
          </q-select>
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.combine" label="是否并线" emit-value map-options dense clearable outlined :options="[
            { value: '是', label: '是' },
            { value: '否', label: '否' },
          ]">
          </q-select>
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.supplierId" :options="supplierList" option-label="supplierName"
            option-value="id" emit-value map-options label="加工工厂" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined dense v-model="queryForm.beginDate" label="订单开始日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.beginDate" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-3 col-11">
          <q-input outlined dense v-model="queryForm.endDate" label="订单结束日期" clearable>
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date v-model="queryForm.endDate" mask="YYYY-MM-DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md-6 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="订单信息" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" title="二维码" icon="qr_code_2"
              @click="toQRcode(props.rowIndex, props.row)" />
            <q-btn round color="primary" size="xs" icon="date_range" @click="plan(props.index, props.row)" title="计划" />
            <q-btn round color="primary" size="xs" icon="edit" @click="detail(props.index, props.row)" />
            <q-btn round color="deep-orange" size="xs" icon="delete_forever"
              @click="removeOrder(props.index, props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_QUANTITY).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td> </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { listAll } from "@/api/erp/customer";
import { list as listYarn } from "@/api/erp/yarn";
import { list as listSupplier } from "@/api/erp/supplier"
import { list } from "@/api/erp/order";
import numbro from "numbro";
export default {
  components: {},
  data() {
    return {
      numbro,
      customerList: [],
      supplierList: [],
      yarnList: [],
      tableData: {},
      queryForm: {},
      loading: false,
      pagination: {
        sortBy: "ORDER_DATE",
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "orderNo",
          align: "center",
          label: "订单编号",
          field: "orderNo",
        },
        {
          name: "customerShortName",
          align: "center",
          label: "客户名称",
          field: "customerShortName",
        },
        {
          name: "customerOrderNo",
          align: "center",
          label: "客户订单号",
          field: "customerOrderNo",
        },
        {
          name: "yarnTypeName",
          align: "center",
          label: "胚纱类型",
          field: "yarnTypeName",
        },
        {
          name: "roundType",
          align: "center",
          label: "成纱形态",
          field: "roundType",
        },
        {
          name: "delivery",
          align: "center",
          label: "是否购销",
          field: "delivery",
        },
        {
          name: "ORDER_DATE",
          align: "center",
          label: "订单日期",
          field: "orderDate",
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "center",
          label: "期望交期",
          field: "deliveryDate",
        },
        {
          name: "orderQuantity",
          align: "center",
          label: "订单数量",
          field: (row) =>
            numbro(row.orderQuantity || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
        },
        {
          name: "orderStatus",
          align: "center",
          label: "订单状态",
          field: (row) => {
            if (row.orderStatus == "0") {
              return "待加工";
            } else if (row.orderStatus == "1") {
              return "部分加工完成";
            } else if (row.orderStatus == "2") {
              return "全部加工完成";
            } else if (row.orderStatus == "3") {
              return "部分已开票";
            } else if (row.orderStatus == "4") {
              return "全部已开票";
            } else if (row.orderStatus == "5") {
              return "订单完成";
            }
          },
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        self.yarnList = response.data.data;
      });
    },
    toAddOrder() {
      this.$router.push("/order/insert");
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      } else {
        self.queryForm.orderBy = null;
      }
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    removeOrder(index, row) {
      var self = this;

      this.$confirm("此操作将永久删除该笔订单并无法恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.$axios
            .delete("order/remove/" + row.orderNo)
            .then(function (response) {
              if (response.data.errorCode == "00000") {
                self.$message({
                  message: "删除成功",
                  type: "success",
                });
                self.query();
              } else {
                self.$message.error(response.data.errorMsg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    plan(index, row) {
      this.$router.push("/order/plan/create/" + row.orderNo);
    },
    detail(index, row) {
      console.log(row);
      this.$router.push("/order/detail/" + row.orderNo);
    },
    toQRcode(index, row) {
      this.$router.push({
        path: "/order/qrcode",
        query: {
          scene: `orderNo=${row.orderNo}`,
          page: "pages/mine/order/detail",
        },
      });
    },
  },
  created: function () {
    console.log("Order created");
  },
  mounted: function () {
    this.listCustomer();
    this.listYarn();
    this.query();
    listSupplier().then((response) => {
      this.supplierList = response.data.data.list;
    });
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}

#queryForm {
  margin-bottom: 20px;
}
</style>